import config from '@packages/config';
import type { KimIFrameQueryType, KimPageTypeProps } from './KimRating.types';

/**
 * KIM template data per page type.
 */
export const templateData: Record<
  KimPageTypeProps,
  {
    id: KimIFrameQueryType['x03'];
    title: KimIFrameQueryType['x05'];
    source: KimIFrameQueryType['x07'];
    iSurveyId: KimIFrameQueryType['i_survey'];
    showInAppView: boolean;
  }
> = {
  storefront: {
    id: '22',
    title: 'BBSTART',
    source: '55',
    iSurveyId: config.customerCentricFeedback?.surveyIdStorefront,
    showInAppView: false,
  },
  detailpage: {
    id: '23',
    title: 'BBDETAIL',
    source: '56',
    iSurveyId: config.customerCentricFeedback?.surveyIdDetailview,
    showInAppView: false,
  },
  search: {
    id: '24',
    title: 'BBPL',
    source: '57',
    iSurveyId: config.customerCentricFeedback?.surveyIdSearch,
    showInAppView: false,
  },
  wishlist: {
    id: '25',
    title: 'BBPL',
    source: '55',
    iSurveyId: config.customerCentricFeedback?.surveyIdWishlist,
    showInAppView: false,
  },
  myaccount: {
    id: '20',
    title: 'UEBER', // Will be overridden via templateParams in the specific pages
    source: '33',
    iSurveyId: config.customerCentricFeedback.surveyIdMyAccount,
    showInAppView: false,
  },
  orderconfirmation: {
    id: '14',
    title: 'BBShop',
    source: '33',
    iSurveyId: config.customerCentricFeedback.surveyIdOrderConfirmation,
    // The app marks its answers with contact channel x12=50.
    showInAppView: true,
  },
};
